import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ideal-product-certs',
  imports: [],
  standalone: true,
  templateUrl: './product-certs.component.html',
  styleUrl: './product-certs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCertsComponent {}
